import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import styles from "./popup.module.scss";
import Images from "assets/Images";

const Popup = ({
  open,
  handleClose,
  handleConfirm,
  title = "Are you sure?",
  message = "Do you really want to delete this record?",
  type="alert"
}) => {
  return (
    <Dialog open={open} onClose={handleClose} className="dialog_sm" classes={{ paper: styles.modalConfirm }}>
      <div className={`flex-column`}>
        <div className={styles.iconBox}>
          {
            type==="alert" &&   <img src={Images.CROSS} alt="cross" width={70} />
          }
         {
            type==="success" &&   <img src={Images.CHECK} alt="cross" width={70} />
          }
        </div>
        <DialogTitle>{title}</DialogTitle>
      </div>
      <DialogContent className={styles.modalBody}>
        <p>{message}</p>
      </DialogContent>
      <DialogActions className={`${styles.modalFooter} justify-content-center`}>
        {type==="alert" && <button onClick={handleClose} className={styles.btnSecondary}>
          Cancel
        </button> }
        <button onClick={handleConfirm} className={type==="alert"?styles.btnDanger:styles.btnSecondary}>
          {type==="alert"? 'Delete':'OK'}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default Popup;
